import React, { useEffect } from 'react';
import styled from 'styled-components';
import { colors, layout } from 'Constants';

import { Container, Icon, Anchor, Button } from 'Components/core';

import InfoBoxHeader from 'Components/InfoBox/InfoBoxHeader';
import InfoBoxContent from 'Components/InfoBox/InfoBoxContent';

// Cards
import CardContainer from 'Components/Card/CardContainer';
import CardHighlighted from 'Components/Card/CardHighlighted';

// Images
import Chart from './images/What-you-pay-1.jpeg';
import { Subscribe, ApiStore } from 'Store';
import Api from 'Root/libs/analytics/Api';
import CODES from 'Root/libs/analytics/CodeDef';
import { SubHeader, TitleHeader } from 'Components/core/Header';






const Card=styled.div` 

flex:2;
min-width:250px ;
margin-right:20px ;
background-color:#ddeefa ;
margin-top:30px ;
color:#000000;
`;

const CardContainerCustom2=styled.div`

display:flex ;
flex-wrap:wrap ;
justify-content:space-between ;

 

> * p{
  padding:20px;
  padding-top:0px ;
}


`;


const Header=styled.div`
  height:50px;
  background-color:#0072bb ;
  color:#ffffff;
  padding:15px;
  padding-left:20px ;
  padding-right:20px ;
  display:flex;
  align-items:center ;
  font-size:20px ;
  font-weight:bold;
  :after {
    content:':'
  }



`;


const CardContainerCustom = styled(CardContainer).attrs(props => ({
  border: false
}))`
  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    > * + * {
      margin-top: 24px;
    }
    > * {
      width: auto;
    }
  }
`;
const CardHighlightedCustom = styled(CardHighlighted).attrs(props => ({
  textAlign: 'left',
  alignItems: 'flex-start'
}))`
  position: relative;
  margin-left: 48px;

  > *:nth-child(2) {
    margin-top: 0;
  }
`;
const CardNumber = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2em;
  position: absolute;
  top: 16px;
  left: -40px;
  width: 60px;
  height: 60px;
  background-color:#081f65;//${colors.accent};
  color: ${colors.textOnAccent};
`;







export default () =>  { 
  
  useEffect(()=>{
    Api.recordAcitity(CODES.MENU_HOW_PW);
  },[]);
  
  return (
    <Subscribe to={[ApiStore]}>
      {state => (
        <Container
          seperation="24px"
          column
          maxWidth
          style={{ margin: 'auto', padding: '32px' }}
        >
          <TitleHeader>Understanding 
              <SubHeader>healthcare terms</SubHeader>
          </TitleHeader>
          <Container column seperation="32px">
           
            <CardContainerCustom2>
              <Card>
                <Header>Deductible</Header>
                <p>
                A set amount you pay each year for covered services before your
                plan starts to pay for covered health care costs.
                </p>
                {typeof state.howPlanWorks?.type === 'string' && (
                  <p>
                  You can use your {state.howPlanWorks.type} toward your
                  deductible.
                  </p>
                )}
              </Card>
              <Card>
                <Header>Copay</Header>
                <p>A flat fee you pay for covered services like doctor visits.</p>
              </Card>
              <Card>
                <Header>Coinsurance</Header>
                <p>
                Once you've met your deductible, you and your health plan share
                the cost of covered health care services. The coinsurance is
                your share of the costs, usually a percentage of the cost of
                care. Your plan details show what portion of the cost you'll
                pay.
                </p>
              </Card>
           
            
              <Card>
                <Header>Out-of-pocket limit</Header>
                <p>
                This is the most you have to pay out of your own pocket each
                year for covered services. This amount may include your
                deductible and your percentage of the costs, depending on your
                plan. And some plans may still have you pay a copay at the time
                of service.
                </p>
              </Card>
              <Card>
                <Header>Premium</Header>
                <p>
                The premium, also called a monthly payment, is what you pay for
                the plan. It's the money that comes out of your paycheck.
                </p>
              </Card>
              <Card style={{backgroundColor:'inherit'}}></Card>
              </CardContainerCustom2>
          </Container>
          <Container column seperation="32px">
            <InfoBoxHeader>What you pay and what your plan pays</InfoBoxHeader>
            <InfoBoxContent style={{marginTop:20}}>
              <img
                alt="You pay until you reach your deductible. At this point, you and your plan share the cost until the out-of-pocket limit is reached. At this point, your plan pays the costs."
                src={Chart}
              />
             
            </InfoBoxContent>
          </Container>
          <Container column seperation="32px">
            <InfoBoxHeader>How to pick a plan – the 4 Cs</InfoBoxHeader>
            <CardContainerCustom>
              <CardHighlightedCustom>
                <CardNumber>1</CardNumber>
                <p>
                  <b>Consider</b> your personal situation. If things have changed
                since last year, you may want to look for benefits that fit
                those needs.
                  <ul>
                    <li>Have your health care needs changed?</li>
                    <li>Do you go to the doctor more often now?</li>
                    <li>Are you taking a special prescription drug?</li>
                    <li>Expecting a baby?</li>
                  </ul>
                </p>
              </CardHighlightedCustom>
              <CardHighlightedCustom>
                <CardNumber>2</CardNumber>
                <p>
                  <b>Compare</b> all the costs
                  <ul>
                    <li>Monthly payment</li>
                    <li>Deductible</li>
                    <li>Coinsurance</li>
                    <li>Copay</li>
                    <li>Out-of-pocket limit</li>
                  </ul>
                </p>
              </CardHighlightedCustom>
            </CardContainerCustom>
            <CardContainerCustom>
              <CardHighlightedCustom>
                <CardNumber>3</CardNumber>
                <p>
                  <b>Check</b> to see if your doctors, hospitals and other health
                care professionals are covered by the plan.
                </p>
              </CardHighlightedCustom>
              <CardHighlightedCustom>
                <CardNumber>4</CardNumber>
                <p>
                  <b>Choose</b> the right plan for your needs.
                </p>
              </CardHighlightedCustom>
            </CardContainerCustom>
          </Container>
        </Container>
      )}
    </Subscribe>
  );
};